export default __webpack_public_path__ + "static/media/service-manual-icon.7a4e0b75.svg";